module.exports = __webpack_public_path__ + "img/myguard_about_02.3fb102c6.png";